import { getAdmin } from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";

export const dashboard = {
  list: {
    key: "list",
    call: () => {
      return getAdmin(`/admin/dashboard`);
    },
  },
  violations: {
    key: "violations",
    call: (page) => {
      const query = buildQueryString({ report_download: false, page });
      return getAdmin(`/admin/dashboard_top_properties_violations/?${query}`);
    },
  },
  unit: {
    key: "unit",
    call: (page, pageSize, year, month, propertyId) => {
      const query = buildQueryString({
        report_download: false,
        page,
        page_size: pageSize,
        year,
        month,
        property_id: propertyId,
      });
      return getAdmin(`/admin/dashboard_top_units_violations/?${query}`);
    },
  },
  unitComplaints: {
    key: "unitComplaints",
    call: (page, pageSize, year, month, propertyId) => {
      const query = buildQueryString({
        report_download: false,
        page,
        page_size: pageSize,
        year,
        month,
        property_id: propertyId,
      });
      return getAdmin(`/admin/dashboard_top_units_complaints/?${query}`);
    },
  },
  apartments: {
    key: "apartments",
    call: (page, pageSize, year, month, propertyId) => {
      const query = buildQueryString({
        report_download: false,
        page,
        page_size: pageSize,
        year,
        month,
        property_id: propertyId,
      });
      return getAdmin(`/admin/dashboard_top_buildings_violations/?${query}`);
    },
  },
  pm: {
    unit: {
      key: "pmUnit",
      call: (page, pageSize, year, month, propertyId) => {
        const query = buildQueryString({
          report_download: false,
          page,
          page_size: pageSize,
          year,
          month,
          property_id: propertyId,
        });
        return getAdmin(`/admin/dashboard/pm/top-units-violations/?${query}`);
      },
    },
    unitComplaints: {
      key: "pmUnitComplaints",
      call: (page, pageSize, year, month, propertyId) => {
        const query = buildQueryString({
          report_download: false,
          page,
          page_size: pageSize,
          year,
          month,
          property_id: propertyId,
        });
        return getAdmin(`/admin/dashboard/pm/top-units-complaints/?${query}`);
      },
    },
    apartments: {
      key: "pmApartments",
      call: (page, pageSize, year, month, propertyId) => {
        const query = buildQueryString({
          report_download: false,
          page,
          page_size: pageSize,
          year,
          month,
          property_id: propertyId,
        });
        return getAdmin(`/admin/dashboard/pm/top-buildings-violations/?${query}`);
      },
    },
  },
  complaints: {

    key: "complaints",
    call: (page) => {
      const query = buildQueryString({ report_download: false, page });
      return getAdmin(`/admin/dashboard_top_properties_complaints/?${query}`);
    },
  },
};
